export default __webpack_public_path__ + "static/media/Shopify-Logo.c62a1bb9.png";